export const HEATING_PREFERENCES_ENABLED = false;
